module.exports = __webpack_public_path__ + "fonts/Montserrat-BlackItalic.f1d0b5e6.ttf";